export const GachaTeamRegistryABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_MONS_PER_TEAM",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "_MOVES_PER_MON",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "_ENGINE",
        "type": "address",
        "internalType": "contract IEngine"
      },
      {
        "name": "_RNG",
        "type": "address",
        "internalType": "contract IGachaRNG"
      },
      {
        "name": "_PREVIOUS_REGISTRY",
        "type": "address",
        "internalType": "contract GachaTeamRegistry"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "ENGINE",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract IEngine"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "FIRST_GAME_EVER_BONUS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "INITIAL_ROLLS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_MONS_PER_TEAM",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_TEAMS_PER_PLAYER",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "NUM_STARTERS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "POINTS_PER_LOSS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "POINTS_PER_WIN",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "PREVIOUS_REGISTRY",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract GachaTeamRegistry"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ROLL_COST",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "STEPS_BITMAP",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "STREAK_BONUS_MAX",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "STREAK_GRACE",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "addQuest",
    "inputs": [
      {
        "name": "preds",
        "type": "tuple[]",
        "internalType": "struct Quests.Predicate[]",
        "components": [
          {
            "name": "op",
            "type": "uint8",
            "internalType": "enum Quests.Op"
          },
          {
            "name": "cmp",
            "type": "uint8",
            "internalType": "enum Quests.Cmp"
          },
          {
            "name": "negate",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "arg",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "operand",
            "type": "int16",
            "internalType": "int16"
          }
        ]
      }
    ],
    "outputs": [
      {
        "name": "questId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "advanceDays",
    "inputs": [
      {
        "name": "n",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "assignExp",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monIds_",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "amounts",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "assignFacets",
    "inputs": [
      {
        "name": "monIdsToAssign",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "facetIds",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "assignMoves",
    "inputs": [
      {
        "name": "monIds_",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "selectionBitmaps",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "assignPoints",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "balanceOf",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "cancelOwnershipHandover",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "completeOwnershipHandover",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "createMon",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "_monStats",
        "type": "tuple",
        "internalType": "struct MonStats",
        "components": [
          {
            "name": "hp",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "stamina",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "speed",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialAttack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialDefense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "type1",
            "type": "uint8",
            "internalType": "enum Type"
          },
          {
            "name": "type2",
            "type": "uint8",
            "internalType": "enum Type"
          }
        ]
      },
      {
        "name": "allowedMoves",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "allowedAbilities",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "keys",
        "type": "bytes32[]",
        "internalType": "bytes32[]"
      },
      {
        "name": "values",
        "type": "bytes32[]",
        "internalType": "bytes32[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "createTeam",
    "inputs": [
      {
        "name": "monIndices",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [
      {
        "name": "slot",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "dayOffset",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "deleteTeam",
    "inputs": [
      {
        "name": "slot",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "editQuest",
    "inputs": [
      {
        "name": "questId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "preds",
        "type": "tuple[]",
        "internalType": "struct Quests.Predicate[]",
        "components": [
          {
            "name": "op",
            "type": "uint8",
            "internalType": "enum Quests.Op"
          },
          {
            "name": "cmp",
            "type": "uint8",
            "internalType": "enum Quests.Cmp"
          },
          {
            "name": "negate",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "arg",
            "type": "uint16",
            "internalType": "uint16"
          },
          {
            "name": "operand",
            "type": "int16",
            "internalType": "int16"
          }
        ]
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "facetData",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monBucket",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "packed",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "firstRoll",
    "inputs": [
      {
        "name": "starterId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "rolledIds",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "getActiveQuest",
    "inputs": [],
    "outputs": [
      {
        "name": "activeDay",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "activeQuestId",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getExp",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getExpAndLevelsForMons",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "ids",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [
      {
        "name": "exp",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "levels",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getExpAndLevelsForTeam",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "teamIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "ids",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "exp",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "levels",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getExpAndLevelsForTeams",
    "inputs": [
      {
        "name": "p0",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p0TeamIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "p1",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p1TeamIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "p0MonIds",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "p0Exp",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "p0Levels",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "p1MonIds",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "p1Exp",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "p1Levels",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getFacetData",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      },
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getFacetDeltaForMon",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct StatDelta",
        "components": [
          {
            "name": "hp",
            "type": "int16",
            "internalType": "int16"
          },
          {
            "name": "atk",
            "type": "int16",
            "internalType": "int16"
          },
          {
            "name": "spAtk",
            "type": "int16",
            "internalType": "int16"
          },
          {
            "name": "def",
            "type": "int16",
            "internalType": "int16"
          },
          {
            "name": "spDef",
            "type": "int16",
            "internalType": "int16"
          },
          {
            "name": "speed",
            "type": "int16",
            "internalType": "int16"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getLevel",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonCount",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonData",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "_monStats",
        "type": "tuple",
        "internalType": "struct MonStats",
        "components": [
          {
            "name": "hp",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "stamina",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "speed",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialAttack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialDefense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "type1",
            "type": "uint8",
            "internalType": "enum Type"
          },
          {
            "name": "type2",
            "type": "uint8",
            "internalType": "enum Type"
          }
        ]
      },
      {
        "name": "moves",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "abilities",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonDataBatch",
    "inputs": [
      {
        "name": "ids",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [
      {
        "name": "stats",
        "type": "tuple[]",
        "internalType": "struct MonStats[]",
        "components": [
          {
            "name": "hp",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "stamina",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "speed",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialAttack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialDefense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "type1",
            "type": "uint8",
            "internalType": "enum Type"
          },
          {
            "name": "type2",
            "type": "uint8",
            "internalType": "enum Type"
          }
        ]
      },
      {
        "name": "moves",
        "type": "uint256[][]",
        "internalType": "uint256[][]"
      },
      {
        "name": "abilities",
        "type": "uint256[][]",
        "internalType": "uint256[][]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonIds",
    "inputs": [
      {
        "name": "start",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "end",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonMetadata",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "key",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonRegistryIndicesForTeam",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "teamIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMonStats",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct MonStats",
        "components": [
          {
            "name": "hp",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "stamina",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "speed",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialAttack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialDefense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "type1",
            "type": "uint8",
            "internalType": "enum Type"
          },
          {
            "name": "type2",
            "type": "uint8",
            "internalType": "enum Type"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMovePool",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "moves",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "unlockLevels",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getMoveSelection",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getOpponentTeamFacets",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "opponent",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "facetIds",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getOpponentTeamMoves",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "opponent",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "moveSelections",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getOrderedLiveTeams",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "slots",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getOwned",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getOwnedMonDetails",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "monIds",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "exp",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "levels",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "facetUnlocked",
        "type": "uint16[]",
        "internalType": "uint16[]"
      },
      {
        "name": "facetEquipped",
        "type": "uint8[]",
        "internalType": "uint8[]"
      },
      {
        "name": "moveSelections",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getPlayerTeams",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "slots",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "teamMonIds",
        "type": "uint256[][]",
        "internalType": "uint256[][]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getQuest",
    "inputs": [
      {
        "name": "questId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "packed",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "count",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getQuestPoolLength",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getRNG",
    "inputs": [
      {
        "name": "seed",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getStepsBitmap",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "pure"
  },
  {
    "type": "function",
    "name": "getTeam",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "teamIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple[]",
        "internalType": "struct Mon[]",
        "components": [
          {
            "name": "stats",
            "type": "tuple",
            "internalType": "struct MonStats",
            "components": [
              {
                "name": "hp",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "stamina",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "speed",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "attack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "defense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialAttack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialDefense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "type1",
                "type": "uint8",
                "internalType": "enum Type"
              },
              {
                "name": "type2",
                "type": "uint8",
                "internalType": "enum Type"
              }
            ]
          },
          {
            "name": "ability",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "moves",
            "type": "uint256[]",
            "internalType": "uint256[]"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTeamCount",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTeams",
    "inputs": [
      {
        "name": "p0",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p0TeamIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "p1",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "p1TeamIndex",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple[]",
        "internalType": "struct Mon[]",
        "components": [
          {
            "name": "stats",
            "type": "tuple",
            "internalType": "struct MonStats",
            "components": [
              {
                "name": "hp",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "stamina",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "speed",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "attack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "defense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialAttack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialDefense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "type1",
                "type": "uint8",
                "internalType": "enum Type"
              },
              {
                "name": "type2",
                "type": "uint8",
                "internalType": "enum Type"
              }
            ]
          },
          {
            "name": "ability",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "moves",
            "type": "uint256[]",
            "internalType": "uint256[]"
          }
        ]
      },
      {
        "name": "",
        "type": "tuple[]",
        "internalType": "struct Mon[]",
        "components": [
          {
            "name": "stats",
            "type": "tuple",
            "internalType": "struct MonStats",
            "components": [
              {
                "name": "hp",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "stamina",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "speed",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "attack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "defense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialAttack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialDefense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "type1",
                "type": "uint8",
                "internalType": "enum Type"
              },
              {
                "name": "type2",
                "type": "uint8",
                "internalType": "enum Type"
              }
            ]
          },
          {
            "name": "ability",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "moves",
            "type": "uint256[]",
            "internalType": "uint256[]"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getUnlockedMoves",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isAssigner",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isOwner",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isOwnerBatch",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "ids",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isPhantomRelayer",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isValidAbility",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "ability",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isValidMove",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "moveSlot",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isWhitelistedOpponent",
    "inputs": [
      {
        "name": "addr",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "levelForExp",
    "inputs": [
      {
        "name": "exp",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "pure"
  },
  {
    "type": "function",
    "name": "migrate",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "migrated",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "modifyMon",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "_monStats",
        "type": "tuple",
        "internalType": "struct MonStats",
        "components": [
          {
            "name": "hp",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "stamina",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "speed",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "attack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "defense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialAttack",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "specialDefense",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "type1",
            "type": "uint8",
            "internalType": "enum Type"
          },
          {
            "name": "type2",
            "type": "uint8",
            "internalType": "enum Type"
          }
        ]
      },
      {
        "name": "movesToAdd",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "movesToRemove",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "abilitiesToAdd",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "abilitiesToRemove",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "modifyMonMetadata",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "keys",
        "type": "bytes32[]",
        "internalType": "bytes32[]"
      },
      {
        "name": "values",
        "type": "bytes32[]",
        "internalType": "bytes32[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "monStats",
    "inputs": [
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "hp",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "stamina",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "speed",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "attack",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "defense",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "specialAttack",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "specialDefense",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "type1",
        "type": "uint8",
        "internalType": "enum Type"
      },
      {
        "name": "type2",
        "type": "uint8",
        "internalType": "enum Type"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "needsMigration",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "onBattleEnd",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "onBattleStart",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "onRoundEnd",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "onRoundStart",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "opponentTeamFacetsPacked",
    "inputs": [
      {
        "name": "opponent",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "phantomKey",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "packedFacets",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "opponentTeamMovesPacked",
    "inputs": [
      {
        "name": "opponent",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "phantomKey",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "packedMoves",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "owner",
    "inputs": [],
    "outputs": [
      {
        "name": "result",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ownershipHandoverExpiresAt",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "result",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "packedExpForMon",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monBucket",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "packedExp",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "playerData",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "pointsBalance",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "removeQuest",
    "inputs": [
      {
        "name": "questId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "renounceOwnership",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "requestOwnershipHandover",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "roll",
    "inputs": [
      {
        "name": "numRolls",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "rolledIds",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "selectedMoveBitmap",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monBucket",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "packed",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "setAssigners",
    "inputs": [
      {
        "name": "toAdd",
        "type": "address[]",
        "internalType": "address[]"
      },
      {
        "name": "toRemove",
        "type": "address[]",
        "internalType": "address[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setOpponentTeam",
    "inputs": [
      {
        "name": "opponent",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monIndices",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "facetIds",
        "type": "uint8[]",
        "internalType": "uint8[]"
      },
      {
        "name": "moveSelections",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setOpponentTeamFor",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monIndices",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "facetIds",
        "type": "uint8[]",
        "internalType": "uint8[]"
      },
      {
        "name": "moveSelections",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setOpponentTeamForPeer",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "opponent",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "monIndices",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "facetIds",
        "type": "uint8[]",
        "internalType": "uint8[]"
      },
      {
        "name": "moveSelections",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setPhantomRelayers",
    "inputs": [
      {
        "name": "relayers",
        "type": "address[]",
        "internalType": "address[]"
      },
      {
        "name": "flag",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setTeamForUser",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "slot",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "monIndices",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "facetIds",
        "type": "uint8[]",
        "internalType": "uint8[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setWhitelistedOpponents",
    "inputs": [
      {
        "name": "toAllow",
        "type": "address[]",
        "internalType": "address[]"
      },
      {
        "name": "toDisallow",
        "type": "address[]",
        "internalType": "address[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "teamGroupsPacked",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "teamOrderPacked",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "transferOwnership",
    "inputs": [
      {
        "name": "newOwner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "updateTeam",
    "inputs": [
      {
        "name": "teamIndex",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "teamMonIndicesToOverride",
        "type": "uint256[]",
        "internalType": "uint256[]"
      },
      {
        "name": "newMonIndices",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "validateMon",
    "inputs": [
      {
        "name": "m",
        "type": "tuple",
        "internalType": "struct Mon",
        "components": [
          {
            "name": "stats",
            "type": "tuple",
            "internalType": "struct MonStats",
            "components": [
              {
                "name": "hp",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "stamina",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "speed",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "attack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "defense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialAttack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialDefense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "type1",
                "type": "uint8",
                "internalType": "enum Type"
              },
              {
                "name": "type2",
                "type": "uint8",
                "internalType": "enum Type"
              }
            ]
          },
          {
            "name": "ability",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "moves",
            "type": "uint256[]",
            "internalType": "uint256[]"
          }
        ]
      },
      {
        "name": "monId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "validateMonBatch",
    "inputs": [
      {
        "name": "mons",
        "type": "tuple[]",
        "internalType": "struct Mon[]",
        "components": [
          {
            "name": "stats",
            "type": "tuple",
            "internalType": "struct MonStats",
            "components": [
              {
                "name": "hp",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "stamina",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "speed",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "attack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "defense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialAttack",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "specialDefense",
                "type": "uint32",
                "internalType": "uint32"
              },
              {
                "name": "type1",
                "type": "uint8",
                "internalType": "enum Type"
              },
              {
                "name": "type2",
                "type": "uint8",
                "internalType": "enum Type"
              }
            ]
          },
          {
            "name": "ability",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "moves",
            "type": "uint256[]",
            "internalType": "uint256[]"
          }
        ]
      },
      {
        "name": "ids",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "event",
    "name": "DayAdvanced",
    "inputs": [
      {
        "name": "by",
        "type": "uint32",
        "indexed": false,
        "internalType": "uint32"
      },
      {
        "name": "newOffset",
        "type": "uint32",
        "indexed": false,
        "internalType": "uint32"
      },
      {
        "name": "newEffectiveDay",
        "type": "uint32",
        "indexed": false,
        "internalType": "uint32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "GachaEvent",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "p0Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "p1Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "GachaMultiEvent",
    "inputs": [
      {
        "name": "battleKey",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "seat0Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "seat1Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "seat2Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "seat3Packed",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "MovesAssigned",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "monIds",
        "type": "uint256[]",
        "indexed": false,
        "internalType": "uint256[]"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipHandoverCanceled",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipHandoverRequested",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipTransferred",
    "inputs": [
      {
        "name": "oldOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "newOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Roll",
    "inputs": [
      {
        "name": "player",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "monIds",
        "type": "uint256[]",
        "indexed": false,
        "internalType": "uint256[]"
      },
      {
        "name": "pointsSpent",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "AlreadyFirstRolled",
    "inputs": []
  },
  {
    "type": "error",
    "name": "AlreadyInitialized",
    "inputs": []
  },
  {
    "type": "error",
    "name": "AlreadyMigrated",
    "inputs": []
  },
  {
    "type": "error",
    "name": "DuplicateMonId",
    "inputs": []
  },
  {
    "type": "error",
    "name": "EmptyMoveSelection",
    "inputs": []
  },
  {
    "type": "error",
    "name": "EmptyPool",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FacetArgsLengthMismatch",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FacetNotUnlocked",
    "inputs": []
  },
  {
    "type": "error",
    "name": "IndexOutOfBounds",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidFacetId",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidMonId",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidMonPosition",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidMoveLane",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidOpcode",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidQuestId",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidStarterId",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidTeamIndex",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidTeamSize",
    "inputs": []
  },
  {
    "type": "error",
    "name": "LengthMismatch",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MonAlreadyCreated",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MonIdTooLarge",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MonNotyetCreated",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MonsPerTeamExceedsInitialRolls",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MoveNotUnlocked",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NewOwnerIsZeroAddress",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoHandoverRequest",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoMoreStock",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoPreviousRegistry",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NonSequentialMonId",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotAssigner",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotEngine",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotFacetOwner",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotFirstRolled",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotMoveOwner",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotOwner",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotWhitelistedOpponent",
    "inputs": []
  },
  {
    "type": "error",
    "name": "PointsOverflow",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TeamCapReached",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TeamNotLive",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TooManyAbilities",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TooManyMoves",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TooManyMovesSelected",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TooManyPredicates",
    "inputs": []
  },
  {
    "type": "error",
    "name": "Unauthorized",
    "inputs": []
  }
] as const;
